import { render } from "./PaymentProvider.vue?vue&type=template&id=1f84e776&scoped=true"
import script from "./PaymentProvider.vue?vue&type=script&lang=js"
export * from "./PaymentProvider.vue?vue&type=script&lang=js"

import "./PaymentProvider.vue?vue&type=style&index=0&id=1f84e776&scoped=true&lang=css"

import exportComponent from "/Users/einarbragi/Code/hlada.is/hlada-vue-mapbox/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f84e776"]])

export default __exports__